import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0a379ed1")

_pushScopeId("data-v-0a379ed1")
const _hoisted_1 = { class: "d-f" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_ImgPreviewer = _resolveComponent("ImgPreviewer")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Donut = _resolveComponent("Donut")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.images, (img, index) => {
      return (_openBlock(), _createBlock("div", {
        key: index,
        class: "img flex-1"
      }, [
        _createVNode(_component_ImgPreviewer, null, {
          default: _withId(() => [
            _createVNode(_component_Pic, {
              src: img,
              fallback: "/img/img.svg",
              style: {"object-fit":"contain","width":"100%","height":"100%"}
            }, null, 8, ["src"])
          ]),
          _: 2
        }, 1024),
        (_ctx.editable)
          ? (_openBlock(), _createBlock(_component_Icon, {
              key: 0,
              name: "close",
              class: "close",
              onClick: ($event: any) => (_ctx.mutate(index))
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_ctx.showIndicator)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["indicator img flex-1 df-cross-center", {progress: _ctx.progress}],
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.useImg && _ctx.useImg(...args)))
        }, [
          (_ctx.progress)
            ? (_openBlock(), _createBlock(_component_Donut, { key: 0 }))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ]))
})